import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/iconPlaybackRate1_1x.svg'

export const IconPlaybackRate1_1x = IconSVG as IconComponent
